export const createNotification = (message = '', type = 'success') => {
    return {
        message,
        type
    }
}